import styled from "styled-components";
import {MainNavCanvasDefaultBox} from "./main-nav-canvas.default.box";

export const MainNavCanvasSIBox = styled(MainNavCanvasDefaultBox)`
    box-shadow: none;
`